export const SIDO_COLOR_MAP = {
  "Seoul-si": "#6366f1",
  "Gyeonggi-do": "#3b82f6",
  "Incheon-si": "#06b6d4",

  "Busan-si": "#ef4444",
  "Daegu-si": "#f59e0b",
  "Daejeon-si": "#10b981",
  "Sejong-si": "#ca8a04",

  "Gyeongsangnam-do": "#f97316",
  "Gyeongsangbuk-do": "#84cc16",

  "Chungcheongbuk-do": "#ec4899",
  "Chungcheongnam-do": "#8b5cf6",

  Jeonbuk: "#a855f7",
  Jeonnamgwanju: "#f43f5e",

  "Gangwon-do": "#22c55e",
  "Jeju-si": "#fb923c"
}

export const SIDO_ORDER = [
  "Seoul-si",
  "Gyeonggi-do",
  "Incheon-si",
  "Busan-si",
  "Daegu-si",
  "Daejeon-si",
  "Sejong-si",
  "Gyeongsangbuk-do",
  "Gyeongsangnam-do",
  "Chungcheongbuk-do",
  "Chungcheongnam-do",
  "Jeonbuk",
  "Jeollanam-do",
  "Gangwon-do",
  "Jeju-si"
]
